// ----------------------------------------------------------------------

/**
 * MUI draws an off switch as a white thumb over a black track at 38% opacity,
 * and lets the thumb's elevation shadow carry its edge. Our shadows are tinted
 * grey and faint, so on a white card the thumb vanished and only a sliver of
 * track showed. The track is opaque instead (the underline border, 3:1 on every
 * surface) and the thumb keeps a hairline edge of its own.
 */
export default function Switch(theme) {
    return {
        MuiSwitch: {
            styleOverrides: {
                track: {
                    opacity: 1,
                    backgroundColor: theme.palette.border.underline,
                },
                thumb: {
                    boxShadow: `0 0 0 1px ${theme.palette.border.input}, ${theme.shadows[1]}`,
                },
                switchBase: {
                    '&.Mui-checked + .MuiSwitch-track': {
                        opacity: 1,
                    },
                    '&.Mui-checked .MuiSwitch-thumb': {
                        boxShadow: theme.shadows[1],
                    },
                    '&.Mui-disabled + .MuiSwitch-track': {
                        opacity: 0.38,
                    },
                },
            },
        },
    };
}
